<template>
  <div>
    <b-modal :id="modal_id" size="md" hide-header hide-footer centered>
      <div>
        <b-button
          v-show="tabActiveKey != 'setday'"
          @click="handleTabBack"
          pill
          class="fe fe-arrow-left"
        />
        <div class="d-block text-center">
          <b-img
            src="/resources/images/logo/journeybinder_logo.png"
            style="width: 25px; height: 25px"
          />
          JourneyBinder
        </div>
      </div>
      <div>
        <div v-show="tabActiveKey == 'bookcomplete'">
          <p><i class="fa fa-clock-o"></i> 30m</p>
          <p>
            <i class="fa fa-map-marker"></i>
            https://my.journeybinder.com/sessions
          </p>
          <p><i class="fa fa-credit-card-alt"></i> {{ plan.price }} USD</p>
        </div>
        <p v-show="tabActiveKey != 'setday'">Wednesday</p>
        <p v-show="tabActiveKey != 'setday'">July 22, 2020</p>
        <p v-show="tabActiveKey != 'setday'">
          <i class="fa fe-bar-chart" />Pacific Standard Time
        </p>
      </div>
      <div role="tablist">
        <a-tabs
          defaultActiveKey="setday"
          :active-key="tabActiveKey"
          class="air-tabs-bordered mb-2"
        >
          <a-tab-pane key="setday">
            <div class="d-block text-center">
              <b-avatar size="72px" variant="info" :src="guide.imgURL">
              </b-avatar>
              <h6>{{ guide.firstname }}</h6>
              <h3>
                Book "{{ plan.title }}" Session with {{ guide.firstname }}
              </h3>
            </div>
            <b-row>
              <b-col>
                <p><i class="fa fa-clock-o"></i> {{ plan.duration }}</p>
                <p>
                  <i class="fa fa-map-marker"></i>
                  https://my.journeybinder.com/sessions
                </p>
                <p class="">
                  <button class="btn-fill">
                    Charity
                  </button>
                  <i class="fa fa-credit-card-alt ml-2"></i>
                  {{ plan.price }} USD
                </p>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col class="d-block text-center">
                <h6>Select a Day</h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-calendar
                  block
                  v-model="value"
                  :date-disabled-fn="dateDisabled"
                  locale="en"
                  @input="handleSetDay"
                >
                </b-calendar>
              </b-col>
            </b-row>
          </a-tab-pane>
          <a-tab-pane key="settime">
            <h5>Select A Time</h5>
            Duration: {{ plan.duration }}
            <b-card
              v-for="(anAvailTime, index) in availTimes"
              :key="index"
              @click="handleSetTime(anAvailTime)"
            >
              <b-card-text>
                {{ anAvailTime.text }}
              </b-card-text>
            </b-card>
          </a-tab-pane>
          <a-tab-pane key="bookcomplete">
            <amazonPayment />
          </a-tab-pane>
        </a-tabs>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { BCalendar } from "bootstrap-vue";
import amazonPayment from "./amazonPayment";
import moment from "moment";

export default {
  name: "profile",
  components: {
    BCalendar,
    amazonPayment
  },
  props: {
    modal_id: {
      type: Number | String
    },
    guide: {
      type: Object | Array,
      required: true
    },
    userProfile: {
      type: Object,
      required: true
    },
    plan: {
      type: Object,
      required: true
    }
  },
  computed: {
    getDate() {
      return moment(this.successBook.date).format("dddd, MMMM DD");
    },
    getTime() {
      return moment(`${this.successBook.date} ${this.successBook.time}`).format(
        "hh:mm A"
      );
    }
  },
  methods: {
    handleSetDay(input) {
      this.bookingDay = input;
      this.tabActiveKey = "settime";
    },
    handleSetTime(input) {
      this.bookingTime = input;
      //Go to Next View
      this.tabActiveKey = "bookcomplete";
    },
    handleBookSessionClick() {
      let dayTime = `${this.bookingDay} ${this.bookingTime.value}`;
      let fullTime = moment(dayTime, "YYYY-MM-DD hh:mm:ss");

      this.$store
        .dispatch("session/createSession", {
          _booked_at: fullTime.toDate(),
          room_id: `${this.guide.userId}_${
            this.$store.getters["user/user"].uid
          }_${moment().unix()}`,
          guide: {
            user_id: this.guide.userId,
            firstname: this.guide.user.firstname,
            lastname: this.guide.user.lastname,
            imgURL: this.guide.user.imgURL
          },
          user: {
            user_id: this.$store.getters["user/user"].uid,
            firstname: this.userProfile.firstname,
            lastname: this.userProfile.lastname,
            imgURL: this.userProfile.imgURL ? this.userProfile.imgURL : null
          },
          plan: {
            id: 1,
            price: this.plan.price,
            title: this.plan.title,
            summary: this.plan.summary
          }
        })
        .then(() => {
          this.$store.dispatch("user/showNotification", {
            title: `'${this.plan.title}' Session Booked`,
            description: "Awesome. You will receive an email.",
            variant: "success"
          });
          this.successBook = { date: this.date, time: this.time, type: "all" };
          this.date = "";
          this.time = "";
          setTimeout(() => {
            this.successBook = null;
          }, 15000);
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
      this.showModal = false;
    },
    handleTabBack() {
      switch (this.tabActiveKey) {
        case "settime":
          this.tabActiveKey = "setday";
          break;
        case "bookcomplete":
          this.tabActiveKey = "settime";
          break;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || day === 13;
    }
  },
  data() {
    return {
      bookingDay: null,
      bookingTime: null,
      showBookingModal: false,
      modalCharity: false,
      value: "",
      tabActiveKey: "setday",
      availTimes: [
        {
          text: "9:30AM",
          value: "09:15:00"
        },
        {
          text: "10:30AM",
          value: "10:30:00"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.btn-fill {
  font-family: "Nunito", sans-serif;
  width: 62px;
  height: 24px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding: 0;
  border-radius: 20px;
}
</style>
